import { Fragment } from 'react';
import AccordionCohabitatonData from 'cohabitation/components/shared/cohabitation-data';
import AccordionCohabitaton from 'cohabitation/components/shared/accordion-cohabitation';
import AccordionResidence from 'cohabitation/components/shared/residence';
import AccordionGenerality from 'cohabitation/components/shared/generality';
import CivilStatus from '../shared/civil-status';

interface CohabitationDetailStepProps {
  stepState: number;
}

const CohabitatonDetailStep = ({ stepState }: CohabitationDetailStepProps): React.ReactElement => {
  return (
    <Fragment>
      {stepState === 0 ? (
        <>
          <AccordionCohabitatonData disabled />
          <AccordionCohabitaton disabled />
        </>
      ) : undefined}
      {stepState === 1 ? (
        <>
          <AccordionCohabitatonData disabled />
          <AccordionResidence disabled />
        </>
      ) : undefined}
      {stepState === 2 ? (
        <>
          <AccordionCohabitatonData disabled />
          <AccordionGenerality disabled />
          <CivilStatus disabled />
        </>
      ) : undefined}
    </Fragment>
  );
};

CohabitatonDetailStep.displayName = 'Cohabitation Detail step component';

export default CohabitatonDetailStep;
